import { useEffect, useRef } from 'react';
import { useAudioSystem } from './useAudioSystem';

export const useClickSound = () => {
  const { playSound } = useAudioSystem({ volume: 0.2 });
  const audioContextInitialized = useRef(false);

  const handleClick = () => {
    // Initialize audio context on first user interaction (for mobile)
    if (!audioContextInitialized.current) {
      audioContextInitialized.current = true;
    }
    playSound(0.15); // 15% volume variation for natural feel
  };

  return handleClick;
};

// Hook for applying click sounds to elements
export const useClickSoundEffect = (elementRef: React.RefObject<HTMLElement>) => {
  const handleClick = useClickSound();

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    element.addEventListener('click', handleClick);

    return () => {
      element.removeEventListener('click', handleClick);
    };
  }, [elementRef, handleClick]);
};
